import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import CustomButton from '../../../components/customButton';
import Tabs from '../../../components/tabs';
import {
  QrCodePreview,
  TrackingSnippetPanel,
  WebEmbedInfoForm,
  WebEmbedTargetingForm
} from '../steps/webEmbedStepContent';
import { isValidDestinationUrl, WEB_PROPERTY_UPDATE_MASK } from '../webEmbedUtils';

const ManageWebEmbedModal = ({
  webEmbed,
  isOpen,
  onCancel,
  onConfirm,
  onDelete,
  isLoading,
  attributionWindows,
  campaignOptions,
  campaignTotalSize,
  onLoadCampaigns,
  selectorLoading,
  selectorError,
  onRetrySelectors
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [draft, setDraft] = useState(webEmbed);

  useEffect(() => {
    setSelectedTab(0);
    setDraft(webEmbed);
  }, [webEmbed]);

  if (!webEmbed || !draft) return null;

  const canConfirm = () => {
    if (
      !draft.name.trim() ||
      !isValidDestinationUrl(draft.destinationUrl) ||
      draft.campaigns.length === 0 ||
      !draft.attributionWindow
    ) {
      return false;
    }

    return true;
  };

  const pages = {
    tabs: [
      {
        name: 'Info',
        content: (
          <div>
            <h2 className="section-header">Editing {webEmbed.name}</h2>
            <h4 className="section-label">Configure the name and destination URL.</h4>
            <WebEmbedInfoForm webEmbed={draft} onChange={setDraft} showDestinationUrl />
          </div>
        )
      },
      {
        name: 'Attribution',
        content: (
          <div>
            <h2 className="section-header">Attribution settings</h2>
            <h4 className="section-label">Manage campaigns and attribution window.</h4>
            <WebEmbedTargetingForm
              webEmbed={draft}
              onChange={setDraft}
              attributionWindows={attributionWindows}
              campaignOptions={campaignOptions}
              campaignTotalSize={campaignTotalSize}
              onLoadCampaigns={onLoadCampaigns}
              isLoading={selectorLoading}
              error={selectorError}
              onRetry={onRetrySelectors}
            />
          </div>
        )
      },
      {
        name: 'Tracking Code',
        content: (
          <div>
            <h2 className="section-header">Tracking code</h2>
            <h4 className="section-label">View the current connection state and snippet.</h4>
            <TrackingSnippetPanel webEmbed={draft} />
          </div>
        )
      },
      {
        name: 'QR Code',
        content: (
          <div>
            <h2 className="section-header">QR code</h2>
            <h4 className="section-label">Scan or open the Web Embed tracking URL.</h4>
            <QrCodePreview webEmbed={draft} />
          </div>
        )
      }
    ]
  };

  return (
    <Modal size="lg" isOpen={isOpen} fade={false} centered id="manage-web-embed-modal">
      <ModalBody>
        <Tabs classes="manage-web-embed-tabs" onTabsChange={setSelectedTab} selectedTab={selectedTab} pages={pages} />
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-secondary btn-danger mr-auto" disabled={isLoading} onClick={() => onDelete(webEmbed)}>
          <i className="uil uil-trash" />
          Delete
        </button>
        <CustomButton handleClick={onCancel} classes="btn-secondary" title="Cancel" disabled={isLoading} />
        <CustomButton
          handleClick={() => onConfirm(draft, WEB_PROPERTY_UPDATE_MASK)}
          classes="btn-primary"
          title="Confirm changes"
          disabled={!canConfirm()}
          loading={isLoading}
        />
      </ModalFooter>
    </Modal>
  );
};

export default ManageWebEmbedModal;
